import { useEffect, useState } from "react";
import { closeModal, Modal, openModal } from "risa-oasis-ui_v2";
import { ModalId } from "../../../enums/modalId";
import { toast } from "@risalabs_frontend_org/oasis-ui-kit";
import OutlineWarningIcon from "../../../svg/outline-warning-icon";
import { ToastMessages } from "../../toasts/toastMessages";

interface DeleteUserModalProps {
  isOpen: boolean;
  memberId: string;
  memberName?: string;
  onDelete: (memberId: string) => Promise<void>;
  onClose: () => void;
}

const MODAL_ID = ModalId.DELETE_USER_MODAL;

const DeleteUserModal = (props: DeleteUserModalProps) => {
  const [isDeleting, setIsDeleting] = useState(false);

  useEffect(() => {
    if (props.isOpen) {
      openModal(MODAL_ID);
    } else {
      closeModal(MODAL_ID);
    }
  }, [props.isOpen]);

  const handleDelete = async () => {
    const memberId = props.memberId;
    setIsDeleting(true);
    try {
      await props.onDelete(memberId);
      props.onClose();
    } catch (error) {
      toast.error(ToastMessages.MEMBER_REMOVED_FAILED);
    } finally {
      setIsDeleting(false);
    }
  };

  const handleCancel = () => {
    props.onClose();
  };

  return (
    <Modal
      dialogId={MODAL_ID}
      onSave={handleDelete}
      onCancel={handleCancel}
      onClose={handleCancel}
      title={"Remove the user"}
      saveButtonText={isDeleting ? "Deleting..." : "Yes, Confirm"}
      cancelText={"No, Cancel"}
      disableSave={isDeleting}
    >
      <div className="flex flex-col items-center justify-center gap-6 px-4 py-6">
        <div className="flex h-14 w-14 items-center justify-center rounded-[2.1875rem] bg-primaryGray-16">
          <OutlineWarningIcon />
        </div>
        <div className="text-center text-h11 font-semiBold leading-body text-black">
          Are you sure you want to delete the user
          {props.memberName ? `, ${props.memberName},` : ""}
          <br />
          this action cannot be reversed
        </div>
      </div>
    </Modal>
  );
};

export default DeleteUserModal;
